import addOnConfig from '../journey-configs/addOn.json';
import eu1Config from '../journey-configs/eea/eu1.json';
import eu2Config from '../journey-configs/eea/eu2.json';
import ie1Config from '../journey-configs/eea/ie1.json';
import mobileConfig from '../journey-configs/global.json';
import gtvConfig from '../journey-configs/gtv.json';
import sg1Config from '../journey-configs/sg/sg1.json';
import sg2Config from '../journey-configs/sg/sg2.json';
import sg3Config from '../journey-configs/sg/sg3.json';
import sg4Config from '../journey-configs/sg/sg4.json';
import sg5Config from '../journey-configs/sg/sg5.json';
import sg6Config from '../journey-configs/sg/sg6.json';
import sgAddOnConfig from '../journey-configs/sg/sgaddon.json';
import sgAllConfig from '../journey-configs/sg/sgall.json';
import spectreConfig from '../journey-configs/spectre.json';
import spectreRetailConfig from '../journey-configs/spectreretail.json';
import spreadbetConfig from '../journey-configs/spreadbet.json';
import uk1Config from '../journey-configs/uk/uk1.json';
import uk2Config from '../journey-configs/uk/uk2.json';
import uk3Config from '../journey-configs/uk/uk3.json';
import uk4Config from '../journey-configs/uk/uk4.json';
import uk5Config from '../journey-configs/uk/uk5.json';
import uk6Config from '../journey-configs/uk/uk6.json';
import uk7Config from '../journey-configs/uk/uk7.json';
import ukAllConfig from '../journey-configs/uk/ukall.json';
import { resolveQueryRegion } from './resolveQueryRegion.ts';

export const journeyConfigByJourneyId = {
  spectre: spectreConfig,
  spectreretail: spectreRetailConfig,
  uk1: uk1Config,
  uk2: uk2Config,
  uk3: uk3Config,
  uk4: uk4Config,
  uk5: uk5Config,
  uk6: uk6Config,
  uk7: uk7Config,
  ukall: ukAllConfig,
  ie1: ie1Config,
  eu1: eu1Config,
  eu2: eu2Config,
  gtv: gtvConfig,
  spreadbet: spreadbetConfig,
  global: mobileConfig,
  addon: addOnConfig,
  sg1: sg1Config,
  sg2: sg2Config,
  sg3: sg3Config,
  sg4: sg4Config,
  sg5: sg5Config,
  sg6: sg6Config,
  sgall: sgAllConfig,
  sgaddon: sgAddOnConfig,
} as const;

export type JourneyId = keyof typeof journeyConfigByJourneyId;

type RawJourneyConfig = (typeof journeyConfigByJourneyId)[JourneyId];

type JourneyAvailability = {
  allowed: boolean;
  reason?: string;
};

function getConfigOnboardingRegion(rawConfig: RawJourneyConfig): string | null | undefined {
  return rawConfig.pegaStartingFields?.OnboardingRegion;
}

export function getJourneyAvailability(journeyId: string, query?: URLSearchParams): JourneyAvailability {
  const rawConfig = journeyConfigByJourneyId[journeyId as JourneyId] as RawJourneyConfig | undefined;

  if (!rawConfig) {
    return { allowed: false, reason: `Journey id not supported: ${journeyId}` };
  }

  const appEnv = import.meta.env.VITE_CUSTOM_ENV;
  if ('nonProdOnly' in rawConfig && rawConfig.nonProdOnly === true && appEnv === 'prod') {
    return {
      allowed: false,
      reason: `Journey id not available in production: ${journeyId}`,
    };
  }

  const configOnboardingRegion = getConfigOnboardingRegion(rawConfig);
  if (
    'onboardingRegionQueryParam' in rawConfig &&
    rawConfig.onboardingRegionQueryParam &&
    (configOnboardingRegion === null || configOnboardingRegion === undefined)
  ) {
    const param = rawConfig.onboardingRegionQueryParam;
    if (!query || !resolveQueryRegion(query, param)) {
      return {
        allowed: false,
        reason: 'Missing required query param: region',
      };
    }
  }

  return { allowed: true };
}
